import { NavLink } from 'react-router-dom';
import { Gavel, PlusCircle, Receipt, Wallet } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/auctions', icon: Gavel, label: 'Auctions' },
  { to: '/create', icon: PlusCircle, label: 'Create' },
  { to: '/my-bids', icon: Receipt, label: 'My Bids' },
  { to: '/wallet', icon: Wallet, label: 'Wallet' },
];

export function BottomNavigation() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background/60 backdrop-blur-2xl border-t border-border/20">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-colors',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground'
              )
            }
          >
            {({ isActive }) => (
              <>
                <item.icon className={cn('w-5 h-5', isActive && 'text-primary')} />
                <span className="text-xs font-medium">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
